module.exports = __webpack_public_path__ + "static/media/file18.bd08971d.jpg";